import React from 'react'
import get from 'lodash/get'
import AutoComplete from '../AutoComplete/AutoComplete'
import PropTypes from "prop-types";
import {matchSorter} from 'match-sorter'
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
// import styles from "*.module.css";
import DialogActions from "@material-ui/core/DialogActions";
// import Button from "@material-ui/core/Button";
import {Button} from "@nzpost/react-components";
import Slide from "@material-ui/core/Slide";
// import "./CountrySelect.css"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const filterOptions = (options, { inputValue }) =>
  matchSorter(options, inputValue, {keys: ['name', 'country']});

const NoMatch = () => {
  return (
    <div>
      <b>
        <font color='black'>An exact match wasn&apos;t found.</font>
      </b>
      <p>
        <font color='#191E28'>
          Try entering the country again or check spelling.
        </font>
      </p>
    </div>
  )
}

export const CountrySelect = (props) => {
  const {
    name,
    label,
    onChange,
    disabled,
    error,
    shrink,
    margin,
    helperText,
    placeholder,
    inputRef,
    excludedCountries,
    onBlur,
    requiresConfirmation = false,
  } = props

  const [countries, setCountries] = React.useState([]);
  const [clicked, setClicked] = React.useState(!!error);
  const [currentCountry, setCurrentCountry] = React.useState(null);
  const [confirmCountry, setConfirmCountry] = React.useState(null);

  const handleClose = (ok) => {
    if (ok)  {
      setCurrentCountry(confirmCountry);
      if (onChange) {
        onChange(confirmCountry);
      }
    }
    setConfirmCountry(null);
  };

  React.useEffect(() => {
    fetch(
      `https://uat-tools.cf.nzpost.co.nz/tools/send-it/api/countries`,
      {
        method: 'get',
        headers: new Headers({
          Accept: 'application/json'
        })
      }
    )
      .then((response) => response.json())
      .then((json) => {
        const countryData = get(json, 'countries', [])
          .filter((country) => !excludedCountries.includes(country.country));

        setCountries( countryData);
      })
  }, []);

  // update error from props when not empty
  React.useEffect(() => {
    if (error) {
      setClicked(true)
    }
  }, [error]);

  const onSuggestionSelected = React.useCallback(
    (evt, optionSelected) => {
      if (!currentCountry || !requiresConfirmation) {
        setCurrentCountry(optionSelected);
        if (onChange) {
          onChange(optionSelected);
        }
      } else {
        setConfirmCountry(optionSelected);
      }
    },
    [onChange]
  )

  const getOptionLabel = (country) => {
    const lbl = !country ? null : get(country, 'name', null);
    return lbl
  }
  return (
    <>
      <Dialog
        className={"dialogBox"}
        open={!!confirmCountry}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Transition}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <div className={"dialogContentContainer"}>
          <DialogTitle><div className="dialogTitle">Are you sure you want to change the country this parcel is going to?</div></DialogTitle>
          <DialogContent>
            <DialogContentText className={"dialogContent"} id="alert-dialog-description">
              The new destination country may have different customs requirements to the country originally selected.
            </DialogContentText>
            <DialogContentText className={"dialogContent"} id="alert-dialog-description">
              Any tariff codes will be removed and will need to be replaced.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="text" color="linkBlue" className={"cancelButton"} onClick={() => handleClose(false)}>
              Cancel
            </Button>
            <Button variant="text" color="linkBlue" className={"removeButton"} onClick={() => handleClose(true)}>
              Change country
            </Button>
          </DialogActions>
        </div>
      </Dialog>
      <AutoComplete
        value={currentCountry}
        onBlur={onBlur}
        inputRef={inputRef}
        suggestions={countries}
        onInputChange={() => {}}
        onChange={onSuggestionSelected}
        filterOptions={filterOptions}
        error={!!error}
        disabled={disabled}
        clicked={clicked}
        label={label}
        placeholder={placeholder}
        name={name}
        freeSolo={false}
        noOptionsText={<NoMatch />}
        autoCompleteParam='no'
        displayLoading={false}
        getOptionLabel={getOptionLabel}
        shrink={shrink}
        margin={margin}
        helperText={helperText}
      />
    </>
  )
}

CountrySelect.propTypes = {
  margin: PropTypes.string,
};

CountrySelect.defaultProps = {
  margin: 'normal',
  inputRef: null,
  excludedCountries: [],
};


export default CountrySelect
